// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumbs-module__root___3zR8U","item":"breadcrumbs-module__item___1r1bd","link":"breadcrumbs-module__link___uTPM0"};